export default "__VITE_ASSET__a60a2071__"